/* eslint-disable import/no-extraneous-dependencies */
import Echo from 'laravel-echo';
import Pusher, { Options } from 'pusher-js';
import { configs } from '../api/configs';

// const BROADCAST_DRIVER = 'realtime';
// const VITE_REALTIME_APP_ID = 'dd3c6f97-ecbf-448c-8d17-71829e4aa362';
// const VITE_REALTIME_APP_SECRET = 'JDDvwsWO9a2q15f0lcXysbyzGwCoiyxM';
// const VITE_REALTIME_SCHEME = 'https';
// const VITE_REALTIME_HOST = 'transportation-198bd673-1ac4-4dd4-8714-671c7b0e89bc.go24.workers.dev';
// const VITE_REALTIME_APP_KEY = '29076114-bdba-40d8-9fb9-e9c07ccee81e';
// const VITE_REALTIME_PORT = 443;

const options: Options = {
  forceTLS: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  wsHost: configs.socket.realtimeHost,
  wsPort: configs.socket.realtimePost,
  wssPort: configs.socket.realtimePost,

  //   auth: {
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       Accept: 'application/json',
  //     },
  //   },
  //   authEndpoint: AUTH_URL,
};
const client = new Pusher(configs.socket.realtimeAppKey, options);
//   broadcaster: 'pusher',
//   key: import.meta.env.VITE_REALTIME_APP_KEY,
//   wsHost: import.meta.env.VITE_REALTIME_HOST,
//   wsPort: import.meta.env.VITE_REALTIME_PORT,
//   wssPort: import.meta.env.VITE_REALTIME_PORT,
//   forceTLS: true,
//   disableStats: true,
//   enabledTransports: ['ws', 'wss'],

const echo = new Echo({
  client,
  broadcaster: 'pusher',
});

window.socketId = '';

echo.connector.pusher.connection.bind('connected', () => {
  console.log('echo is connected');
  window.socketId = echo.socketId();
});

const EchoSocket = {
  seatSelection: ({
    channel,
    onSelected,
    onUnselected,
  }: {
    channel: string;
    onSelected: (data: any) => void;
    onUnselected: (data: any) => void;
  }) => {
    echo.channel(`realtime.${channel}`).listen('.seat_selected', onSelected).listen('.unselected', onUnselected);

    return () =>
      echo
        .channel(`realtime.${channel}`)
        .stopListening('.seat_selected', onSelected)
        .stopListening('.unselected', onUnselected);
    // .listen('.seat_unavailble', onUnavailble);
  },

  seatAlreadySelected: ({
    channel,
    onSeatBusy,
    onSeatBooked,
    onSeatCancelled,
  }: {
    channel: string;
    onSeatBusy: (data: any) => void;
    onSeatBooked: (data: any) => void;
    onSeatCancelled: (data: any) => void;
  }) => {
    console.log('seatAlreadySelected been listen');
    echo
      .channel(`realtime.${channel}`)
      // .listen('.seat_busy', (data: any) => onSeatBusy && onSeatBusy(data))
      // .listen('.seat_booked', (data: any) => onSeatBooked && onSeatBooked(data))
      // .listen('.seat_cancelled', (data: any) => onSeatCancelled && onSeatCancelled(data));
      .listen('.seat_busy', onSeatBusy)
      .listen('.seat_booked', onSeatBooked)
      .listen('.seat_cancelled', onSeatCancelled);
    // .listen('.seat_cancelled', (data: any) => onSeatCancelled && onSeatCancelled(data));

    return () => {
      console.log('seatAlreadySelected remove has been called');
      echo
        .channel(`realtime.${channel}`)
        .stopListening('.seat_busy', onSeatBusy)
        .stopListening('.seat_booked', onSeatBooked)
        .stopListening('.seat_cancelled', onSeatCancelled);
    };
  },

  refreshPayment: (channel: string, onPaymentSuccess: () => void) => {
    echo.channel(`realtime.${channel}`).listen('.payment_success', () => onPaymentSuccess && onPaymentSuccess());

    return () =>
      echo
        .channel(`realtime.${channel}`)
        .stopListening('.payment_success', () => onPaymentSuccess && onPaymentSuccess());
  },
};

// echo.channel(`realtime.nham24`).listen('.eating', e => {
//   console.log(e);
// });

export default EchoSocket;
